import React from 'react';
import './StepNavigation.css';

const StepNavigation = ({ currentStep, totalSteps, onNext, onPrevious, canProceed, isOptional }) => {
  const isNextDisabled = !canProceed;
  const isLastStep = currentStep >= totalSteps - 1;
  const nextLabel = isLastStep
    ? 'Request Quote →'
    : (isOptional ? 'Skip / Next Step →' : 'Next Step →');

  return (
    <div className="step-navigation">
      <div className="step-indicator">
        {currentStep + 1} / {totalSteps}
        {isOptional && <span className="optional-badge">Optional</span>}
      </div>
      <div className="navigation-buttons">
        {currentStep > 0 && (
          <button
            type="button"
            className="nav-button prev-button"
            onClick={onPrevious}
          >
            ← Previous
          </button>
        )}
        <button
          type="button"
          className={`nav-button next-button${isNextDisabled ? ' disabled' : ''}`}
          onClick={onNext}
          disabled={isNextDisabled}
          aria-disabled={isNextDisabled}
        >
          {nextLabel}
        </button>
      </div>
    </div>
  );
};

export default StepNavigation;
